import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { ModalModule } from 'ngx-dynamic-modal';
import { TooltipModule} from 'ngx-bootstrap/tooltip';
import { ClientModule} from './client/client.module';

import { NgxJsonViewerModule } from 'ngx-json-viewer';

// Import routing module
import {AppRoutingModule} from './app.routing';

// Import 3rd party components
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {TabsModule} from 'ngx-bootstrap/tabs';
import { DpDatePickerModule} from 'ng2-date-picker';
//import {ChartsModule} from 'ng2-charts/ng2-charts';
import { OrderModule} from 'ngx-order-pipe';

import {
    FullLayoutComponent,
    SimpleLayoutComponent
} from './core/containers';

const APP_CONTAINERS = [
    FullLayoutComponent,
    SimpleLayoutComponent
];
import {
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES
} from './core/directives';

const APP_DIRECTIVES = [
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES
];

/** Modules */
import {Ng2Webstorage} from 'ngx-webstorage';
import {SharedModule} from './shared/shared.module';
import {PhoneModule} from './phone/phone.module';

/** Components CORE */
import {AppComponent} from './app.component';
import {HeaderComponent} from './core/components/layout/header/header.component';
import {SidebarComponent} from './core/components/layout/sidebar/sidebar.component';
import {NavbarComponent} from './core/components/layout/navbar/navbar.component';
import {FooterComponent} from './core/components/layout/footer/footer.component';
import {SidebarLeftComponent} from './core/components/layout/sidebar-left/sidebar-left.component';
import {APP_SIDEBAR_NAV} from './core/components/layout/sidebar-menu/sidebar-menu.component';
import {LoginComponent} from './core/components/login/login.component';
import {SelectVnaPortalComponent} from './core/components/portal/selector/vna/select-vna-portal.component';

/** Service */

import {AuthGuardService} from './core/service/auth-guard.service';
import {AuthService} from './core/service/auth.service';
import {ApiService} from './core/service/api.service';
import {EnvironmentService} from './core/service/environment.service';
import {DatesParserService} from './core/service/dates_parser.service';


import {HttpInterceptorService } from './core/service/http-interceptor.service';
import { UserbarComponent } from './core/components/layout/userbar/userbar.component';
import {VnaPortalService} from './core/service/vna-portal.service';

import {NgxSelectModule} from 'ngx-select-ex';
import {MessagingService} from './core/service/messaging.service';
import { DashboardComponent } from './core/components/dashboard/dashboard.component';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {WebSocketService} from './core/service/web-socket-service';
import { ActionHistoryComponent } from './shared/components/action-history/action-history.component';
import {RobinsonModule} from './robinson/robinson.module';
import { ListServicesComponent } from './core/components/services/list-services/list-services.component';
import {VnaServicesService} from './core/service/vna-services.service';
import { EditServiceComponent } from './core/components/services/edit-service/edit-service.component';
import {AceEditorModule} from 'ng2-ace-editor';


@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        BsDropdownModule.forRoot(),
        TabsModule.forRoot(),
        //ChartsModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        Ng2Webstorage,
        SharedModule,
        PhoneModule,
        NgxSelectModule,
        ModalModule,
       // TagInputModule,
        BrowserAnimationsModule,
        DpDatePickerModule,
        TooltipModule.forRoot(),
        ClientModule,
        RobinsonModule,
        OrderModule,
        AceEditorModule,
        NgxJsonViewerModule
    ],
    declarations: [
        AppComponent,
        ...APP_CONTAINERS,
        ...APP_DIRECTIVES,
        HeaderComponent,
        SidebarComponent,
        NavbarComponent,
        FooterComponent,
        SidebarLeftComponent,
        APP_SIDEBAR_NAV,
        LoginComponent,
        UserbarComponent,
        SelectVnaPortalComponent,
        DashboardComponent,
        SelectVnaPortalComponent,
        ActionHistoryComponent,
        ListServicesComponent,
        EditServiceComponent
    ],
    providers: [
        AuthGuardService,
        AuthService,
        ApiService,
        EnvironmentService,
        DatesParserService,
        VnaPortalService,
        MessagingService,
        WebSocketService,
        VnaServicesService,
        { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/app.module.ts